export const loginRoute = '/login';

export const loggedInRoute = '';

export const notFoundRoute = '/404';

export const defaultUserRoute = '';

export const loggedNotificationInRoute = '/user-notifications';

export const schedulerSimulatorRoute = '/scheduler/simulator';



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/config/routes.config.ts